import { Route } from 'react-router-dom';

import { RoutesInternal } from 'theSource/components';
import { Unum, UnumApplication} from './Unum';

export const PluginWrapper = () => {
  return (
    <RoutesInternal>
      <Route path="/plansource_connect_unum" element={<Unum />} />
      <Route path="/" element={<Unum />} />
      <Route
        path="/plansource_connect_unum/application"
        element={<UnumApplication />}
      />
    </RoutesInternal>
  );
};
